import { Pipe, PipeTransform } from '@angular/core';

import { QueryApiModel } from '../../modules/cart/models/query-api.model';

@Pipe({ name: 'valCartTotal' })
export class ValCartTotalPipe implements PipeTransform {
    transform(cart: Array<QueryApiModel>, trigger = 0): number {
        if (!cart) { return 0; }
        return cart.map(x => x.Price * x.quantity).reduce((a, b) => a += b, 0);
    }
}
